export const DashboardKeys = {
  Deep1: (v: any) => ['DashboardKeys', 'Deep1', v],
  Deep2: (label: string, v: any) => ['DashboardKeys', 'Deep2', label, v],
  Deep3: (v: any) => ['DashboardKeys', 'Deep3', v],
  Deep4: (v: any) => ['DashboardKeys', 'Deep4', v]
} as const;
